<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="
        isEdit
          ? $t('OPPORTUNITY_PIPELINES.STAGES.EDIT_TITLE')
          : $t('OPPORTUNITY_PIPELINES.STAGES.NEW_TITLE')
      "
    />

    <form class="row" @submit.prevent="submit">
      <div class="medium-12 columns">
        <label :class="{ error: $v.localStage.name.$error }">
          {{ $t('OPPORTUNITY_PIPELINES.STAGES.NAME') }}
          <input
            v-model.trim="localStage.name"
            type="text"
            @input="$v.localStage.name.$touch"
          />
          <span v-if="$v.localStage.name.$error" class="message">
            {{ $t('OPPORTUNITY_PIPELINES.STAGES.NAME_REQUIRED') }}
          </span>
        </label>

        <label>
          {{ $t('OPPORTUNITY_PIPELINES.STAGES.DESCRIPTION') }}
          <input v-model.trim="localStage.description" type="text" />
        </label>

        <label>
          {{ $t('OPPORTUNITY_PIPELINES.STAGES.COLOR') }}
          <input v-model="localStage.color" type="color" />
        </label>

        <label>
          {{ $t('OPPORTUNITY_PIPELINES.STAGES.SLA') }}
          <input
            :value="localStage.sla_days"
            type="number"
            min="0"
            step="1"
            inputmode="numeric"
            @input="onSlaDaysInput"
          />
        </label>
      </div>

      <div class="modal-footer">
        <woot-button
          type="button"
          color-scheme="secondary"
          @click="$emit('close')"
        >
          {{ $t('OPPORTUNITY_PIPELINES.ACTIONS.CANCEL') }}
        </woot-button>
        <woot-button
          :is-loading="isSaving"
          :disabled="$v.localStage.name.$invalid"
        >
          {{ $t('OPPORTUNITY_PIPELINES.ACTIONS.SAVE') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { sanitizeIntegerInput } from 'dashboard/helper/numericInputHelper';

const defaultStage = () => ({
  name: '',
  description: '',
  color: '#3B82F6',
  sla_days: 0,
});

export default {
  props: {
    stage: {
      type: Object,
      default: () => ({}),
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localStage: defaultStage(),
    };
  },
  validations: {
    localStage: {
      name: { required },
    },
  },
  computed: {
    isEdit() {
      return !!this.stage.id;
    },
  },
  watch: {
    stage: {
      immediate: true,
      handler(stage) {
        this.localStage = {
          ...defaultStage(),
          ...stage,
        };
      },
    },
  },
  methods: {
    onSlaDaysInput(event) {
      const sanitized = sanitizeIntegerInput(event.target.value);
      event.target.value = sanitized;
      this.localStage.sla_days = sanitized === '' ? '' : Number(sanitized);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.$emit('submit', {
        ...this.localStage,
        color: this.localStage.color || '#3B82F6',
        sla_days: Number(this.localStage.sla_days || 0),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-footer {
  display: flex;
  gap: var(--space-small);
  justify-content: flex-end;
  width: 100%;
}
</style>
